import { InfoOutlinedIcon } from "@l2r-front/l2r-icons"
import { styled } from "@l2r-front/l2r-ui"

export const ScrollableWrapper = styled("div")(({ theme }) => ({
    cursor: "grab",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, -8),
    height: "fit-content",
    overflowX: "auto",
    width: `calc(100 % + ${theme.spacing(2 * 8)})`,
}))

export const ChartWrapper = styled("div")(() => ({
    minWidth: 500,
    display: "flex",
    flexDirection: "column",
    width: "100%",
}))

export const NoBudgetInfo = styled("div")(({ theme }) => ({
    margin: theme.spacing(8, 8, 0),
    display: "flex",
    flexDirection: "row",
}))

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
    color: theme.palette["action/disabled"].main,
    height: 22,
    marginRight: theme.spacing(2),
}))